import { useFormik } from "formik";
import { useEffect } from "react";
import { SketchLineEditor, LineProps } from "ui-components";
import { getNanoId } from "utils";

import {
	useSetActive,
	useSelectSketch,
	useSelectFeatureId,
	useSketchGeojson,
	useIsNewSketch,
	useDeleteFeature,
	useUpdateSketchGeojson,
} from "~map-view/states/sketch";
interface Props {
	active: string;
}

export const LineEditor = ({ active }: Props) => {
	const updateSketchGeojson = useUpdateSketchGeojson();
	const sketchGeojson = useSketchGeojson();
	const selectFeatureId = useSelectFeatureId();
	const isNewSketch = useIsNewSketch();
	const selectSketch = useSelectSketch();
	const setActive = useSetActive();
	const deleteFeature = useDeleteFeature();
	const form = useFormik<LineProps>({
		initialValues: {
			colour: "#fff",
			width: 0,
			opacity: 0,
			id: getNanoId(),
		},
		onSubmit: (values, helpers) => {
			if (!selectFeatureId || !sketchGeojson) return;

			updateSketchGeojson(values, "style");

			if (isNewSketch(selectSketch?.id ?? "")) setActive("Create Sketch");
			else setActive("edit-sketch");

			helpers.resetForm();
		},
	});

	useEffect(() => {
		void form.setValues({
			...form.values,
			id: getNanoId(),
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleDelete = () => {
		deleteFeature(selectFeatureId);
		if (isNewSketch(selectSketch?.id ?? "")) setActive("Create Sketch");
		else setActive("edit-sketch");
	};

	if (active === "linestring") {
		return (
			<SketchLineEditor
				form={form}
				onDelete={handleDelete}
			/>
		);
	} else return null;
};
